import React, { useState } from 'react';

const featuredReviews = [
  {
    id: 1,
    name: 'Maria',
    meta: '8 reviews • 0 photos',
    time: '21 weeks ago',
    rating: 5,
    text:
      'I highly recommend Edgar Law Firm. I was transferred from another law firm that wasn’t giving my case the attention it needed, and the difference with Edgar Law was immediate. Both Edgar and the paralegal, Jessica, would call me with updates on my case, which made me feel reassured and informed throughout the process. Jessica was always professional, helpful, and very informative when answering my questions. Their consistent communication and professionalism made the entire experience much smoother.',
    textEs:
      'Recomiendo ampliamente a Edgar Law Firm. Fui transferida de otro despacho de abogados que no le estaba dando a mi caso la atención que necesitaba, y la diferencia con Edgar Law fue inmediata. Tanto Edgar como la asistente legal, Jessica, me llamaban con actualizaciones sobre mi caso, lo que me hizo sentir tranquila e informada durante todo el proceso. Jessica siempre fue profesional, amable y muy informativa al responder mis preguntas. Su comunicación constante y profesionalismo hicieron que toda la experiencia fuera mucho más fluida.',
    accent: '#0b5d4b',
  },
  {
    id: 2,
    name: 'David Harris',
    meta: 'Local Guide • 10 reviews • 4 photos',
    time: '10 weeks ago',
    rating: 5,
    text:
      'I had a great experience with Edgar. Great at explaining the entire process and the price was more than fair considering the prices I got from other firms. Thank you.',
    textEs:
      'Tuve una excelente experiencia con Edgar. Fue muy claro al explicar todo el proceso y el precio fue más que justo considerando los precios que recibí de otros despachos. Gracias.',
    accent: '#123c73',
  },
  {
    id: 3,
    name: 'JON CORONA',
    meta: '1 review • 0 photos',
    time: '24 weeks ago',
    rating: 5,
    text:
      'We at Cruz Industrial Truck dba Cruz Tire are very happy with Edgar Lopez Law firm. Edgar Lopez Law takes care of all of our personal and business cases effectively from start to finish. We are walked through the entire process as it unfolds. The group upheld a high level of transparency, respect and professionalism. We are grateful for their time and efforts. Thank you once again Edgar Lopez Law firm.',
    textEs:
      'En Cruz Industrial Truck dba Cruz Tire estamos muy contentos con Edgar Lopez Law Firm. Edgar Lopez Law se encarga de todos nuestros casos personales y comerciales de manera eficaz de principio a fin. Nos guían durante todo el proceso conforme avanza. El grupo mantuvo un alto nivel de transparencia, respeto y profesionalismo. Estamos agradecidos por su tiempo y esfuerzo. Gracias una vez más, Edgar Lopez Law Firm.',
    accent: '#1479d1',
  },
  {
    id: 4,
    name: 'David Friedman',
    meta: 'Local Guide • 18 reviews • 6 photos',
    time: '24 weeks ago',
    rating: 5,
    text:
      'I’ve worked with Edgar Lopez Law for a long time. I met Edgar while going to CSUSB. He has always been trustworthy, hard-working, and the kind of person that you want in your corner if you are submitting a personal injury claim.',
    textEs:
      'He trabajado con Edgar Lopez Law desde hace mucho tiempo. Conocí a Edgar mientras asistía a CSUSB. Siempre ha sido una persona confiable, trabajadora y del tipo de persona que quieres de tu lado si estás presentando un reclamo por lesiones personales.',
    accent: '#8b6b61',
  },
];

const layoutReviews = [
  {
    id: 5,
    name: 'Verified Client',
    meta: 'Auto Accident Case • California',
    time: '2 weeks ago',
    rating: 5,
    text:
      'From the first call, everything was handled clearly and professionally. I always knew what was happening with my case, and that made a huge difference during a stressful time.',
    textEs:
      'Desde la primera llamada, todo se manejó con claridad y profesionalismo. Siempre supe lo que estaba pasando con mi caso, y eso hizo una gran diferencia durante un momento estresante.',
    accent: '#1f2a44',
    isPlaceholder: false,
  },
  {
    id: 6,
    name: 'Recent Client',
    meta: 'Personal Injury • Southern California',
    time: '3 weeks ago',
    rating: 5,
    text:
      'Communication was consistent, and the process was explained step by step. I never felt lost or ignored. The team made a difficult situation feel much more manageable.',
    textEs:
      'La comunicación fue constante y el proceso se explicó paso a paso. Nunca me sentí perdido ni ignorado. El equipo hizo que una situación difícil se sintiera mucho más manejable.',
    accent: '#ae925e',
    isPlaceholder: false,
  },
  {
    id: 7,
    name: 'Case Client',
    meta: 'Vehicle Collision • Client Feedback',
    time: '1 week ago',
    rating: 5,
    text:
      'What stood out the most was how organized everything was. Every update came at the right time, and I felt supported throughout the process.',
    textEs:
      'Lo que más destacó fue lo organizado que estaba todo. Cada actualización llegó en el momento correcto y me sentí respaldado durante todo el proceso.',
    accent: '#21314B',
    isPlaceholder: false,
  },
  {
    id: 8,
    name: 'Verified Client',
    meta: 'Injury Claim • California',
    time: '5 days ago',
    rating: 5,
    text:
      'Professional, respectful, and responsive. The experience felt personal, and I appreciated how clearly everything was explained from start to finish.',
    textEs:
      'Profesionales, respetuosos y atentos. La experiencia se sintió personal, y aprecié lo claramente que se explicó todo de principio a fin.',
    accent: '#0f5b78',
    isPlaceholder: false,
  },
  {
    id: 9,
    name: 'Recent Client',
    meta: 'Accident Case • Client Feedback',
    time: '6 days ago',
    rating: 5,
    text:
      'The team stayed in contact with me, answered my questions quickly, and made sure I understood what was happening at every stage.',
    textEs:
      'El equipo se mantuvo en contacto conmigo, respondió mis preguntas rápidamente y se aseguró de que entendiera lo que estaba pasando en cada etapa.',
    accent: '#7a5c3e',
    isPlaceholder: false,
  },
  {
    id: 10,
    name: 'Verified Client',
    meta: 'Personal Injury Matter • California',
    time: '4 weeks ago',
    rating: 5,
    text:
      'I appreciated the professionalism and the steady communication. It gave me confidence that my case was being taken seriously.',
    textEs:
      'Aprecié el profesionalismo y la comunicación constante. Eso me dio confianza de que mi caso estaba siendo tomado en serio.',
    accent: '#355c7d',
    isPlaceholder: false,
  },
  {
    id: 11,
    name: 'Client Feedback',
    meta: 'Collision Claim • Southern California',
    time: '9 days ago',
    rating: 5,
    text:
      'Everything felt efficient and well coordinated. I was never left guessing, and that level of follow-through really mattered to me.',
    textEs:
      'Todo se sintió eficiente y bien coordinado. Nunca me dejaron con dudas, y ese nivel de seguimiento realmente fue importante para mí.',
    accent: '#6a4c93',
    isPlaceholder: false,
  },
  {
    id: 12,
    name: 'Verified Client',
    meta: 'Accident Consultation • California',
    time: '12 days ago',
    rating: 5,
    text:
      'The communication and professionalism were the biggest highlights for me. I felt heard, respected, and well informed the whole way through.',
    textEs:
      'La comunicación y el profesionalismo fueron lo más destacado para mí. Me sentí escuchado, respetado y bien informado durante todo el proceso.',
    accent: '#146c94',
    isPlaceholder: false,
  },
];

const reviews = [...featuredReviews, ...layoutReviews];

const styles = {
  page: {
    minHeight: '100vh',
    background:
      'linear-gradient(180deg, #f6f4ef 0%, #ffffff 22%, #f8f6f1 100%)',
    padding: '72px 20px 96px',
    color: '#21314B',
    fontFamily:
      'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  shell: {
    maxWidth: '1240px',
    margin: '0 auto',
  },
  hero: {
    textAlign: 'center',
    marginBottom: '48px',
  },
  eyebrow: {
    display: 'inline-block',
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    fontSize: '0.78rem',
    fontWeight: 700,
    color: '#ae925e',
    marginBottom: '14px',
  },
  title: {
    fontSize: 'clamp(2.2rem, 4vw, 4rem)',
    lineHeight: 1.04,
    margin: '0 0 14px',
    fontWeight: 800,
    color: '#21314B',
  },
  subtitle: {
    maxWidth: '760px',
    margin: '0 auto',
    fontSize: '1.05rem',
    lineHeight: 1.75,
    color: '#4b5563',
  },
  statsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '16px',
    marginBottom: '34px',
  },
  statCard: {
    background: '#ffffff',
    border: '1px solid rgba(33, 49, 75, 0.08)',
    borderRadius: '18px',
    padding: '22px 18px',
    boxShadow: '0 18px 55px rgba(12, 22, 38, 0.06)',
    textAlign: 'center',
  },
  statNumber: {
    fontSize: '1.9rem',
    fontWeight: 800,
    color: '#21314B',
    marginBottom: '8px',
  },
  statLabel: {
    fontSize: '0.98rem',
    color: '#6b7280',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '24px',
    padding: '26px',
    boxShadow: '0 22px 65px rgba(10, 20, 35, 0.08)',
    border: '1px solid rgba(33, 49, 75, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    position: 'relative',
    overflow: 'hidden',
  },
  topBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '6px',
    background: 'linear-gradient(90deg, #21314B 0%, #ae925e 100%)',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
  },
  avatar: {
    width: '58px',
    height: '58px',
    borderRadius: '999px',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.45rem',
    fontWeight: 700,
    flexShrink: 0,
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.15)',
  },
  nameWrap: {
    minWidth: 0,
  },
  name: {
    margin: 0,
    fontSize: '1.18rem',
    fontWeight: 800,
    color: '#21314B',
  },
  meta: {
    marginTop: '4px',
    color: '#6b7280',
    fontSize: '0.95rem',
    lineHeight: 1.45,
  },
  ratingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  stars: {
    color: '#f5b301',
    fontSize: '1.08rem',
    letterSpacing: '0.08em',
  },
  time: {
    color: '#6b7280',
    fontSize: '0.96rem',
    fontWeight: 600,
  },
  reviewText: {
    margin: 0,
    color: '#334155',
    fontSize: '1rem',
    lineHeight: 1.9,
  },
  badge: {
    alignSelf: 'flex-start',
    background: 'rgba(174, 146, 94, 0.12)',
    color: '#8b6a2d',
    border: '1px solid rgba(174, 146, 94, 0.28)',
    borderRadius: '999px',
    padding: '8px 12px',
    fontSize: '0.8rem',
    fontWeight: 700,
    letterSpacing: '0.03em',
  },
  note: {
    marginTop: '34px',
    textAlign: 'center',
    color: '#6b7280',
    fontSize: '0.95rem',
    lineHeight: 1.7,
  },
};

function renderStars(rating) {
  return '★'.repeat(rating) + '☆'.repeat(5 - rating);
}

function ReviewCard({ review, styles }) {
  const [isSpanish, setIsSpanish] = useState(false);
  const canTranslate = Boolean(review.textEs);
  const displayText = isSpanish && review.textEs ? review.textEs : review.text;
  const languageLabel = isSpanish ? 'Versión en español' : 'English version';

  return (
    <article key={review.id} style={styles.card}>
      <div
        style={{
          ...styles.topBar,
          background: `linear-gradient(90deg, ${review.accent} 0%, #ae925e 100%)`,
        }}
      />

      <div style={styles.header}>
        <div
          style={{
            ...styles.avatar,
            background: review.accent,
          }}
        >
          {review.name.charAt(0)}
        </div>

        <div style={styles.nameWrap}>
          <h3 style={styles.name}>{review.name}</h3>
          <div style={styles.meta}>{review.meta}</div>
        </div>
      </div>

      <div style={styles.ratingRow}>
        <span style={styles.stars}>{renderStars(review.rating)}</span>
        <span style={styles.time}>{review.time}</span>
      </div>

      <div className="review-text-wrap">
        {canTranslate && isSpanish && (
          <span className="review-text-language-pill">Traducción activa</span>
        )}
        <p className={isSpanish ? 'review-text is-spanish' : 'review-text'}>{displayText}</p>
      </div>

      {canTranslate && (
        <>
          <button
            type="button"
            className={isSpanish ? 'review-translate-button is-spanish' : 'review-translate-button'}
            onClick={() => setIsSpanish((prev) => !prev)}
          >
            {isSpanish ? 'View in English' : 'Translate to Spanish'}
          </button>
          <span className="review-translate-hint">{languageLabel}</span>
        </>
      )}

      {review.isPlaceholder && (
        <span style={styles.badge}>Placeholder for verified review</span>
      )}
    </article>
  );
}

function Reviews() {
  return (
    <section style={styles.page}>
      <div style={styles.shell}>
        <div style={styles.hero}>
          <span style={styles.eyebrow}>Client Testimonials</span>
          <h1 style={styles.title}>Real feedback builds real trust.</h1>
          <p style={styles.subtitle}>
            These reviews highlight the communication, professionalism, and
            support clients remember most. The first four cards below use the
            reviews shown in your screenshot, and the additional cards are
            anonymized review-style entries so the page feels fuller while you
            continue collecting more verified testimonials.
          </p>
        </div>

        <div style={styles.statsRow}>
          <div style={styles.statCard}>
            <div style={styles.statNumber}>5★</div>
            <div style={styles.statLabel}>Visual trust signal</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statNumber}>4</div>
            <div style={styles.statLabel}>Real reviews added</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statNumber}>8</div>
            <div style={styles.statLabel}>Anonymized entries added</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statNumber}>24/7</div>
            <div style={styles.statLabel}>Reputation working for you</div>
          </div>
        </div>

        <div style={styles.grid}>
          {reviews.map((review) => (
            <ReviewCard key={review.id} review={review} styles={styles} />
          ))}
        </div>

        <p style={styles.note}>
          For credibility and compliance, continue replacing anonymized entries with
          real, verified client reviews before publishing this section publicly.
        </p>
      </div>
    </section>
  );
}

export default Reviews;